module.exports = __webpack_public_path__ + "media/applications/assets/images/size-info/full_print_tanktop-e4ceced3c3d75ee8594364259589b86d.png";